import { useParams } from 'react-router-dom';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useState } from 'react';
import TrackOrderLoadingScreen from './TrackOrderLoadingScreen';
import TrackOrderScreen from './TrackOrderScreen';
import { useSelector } from '../../redux/store';

type TrackOrderScreenProps = {
    focusKey: string;
};
const TrackOrderScreenLayout = ({ focusKey: focusKeyParam }: TrackOrderScreenProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { orderId } = useParams();
    const { last_order } = useSelector((state) => state.orders);
    const { ref, focusKey, focusSelf } = useFocusable({
        focusKey: focusKeyParam,
    });

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} className="relative w-full h-full flex justify-evenly">
                {isLoading || !last_order ? (
                    <TrackOrderLoadingScreen
                        focusKey="TRACK-ORDER-LOADING-SCREEN"
                        orderId={orderId || ''}
                        setIsLoading={setIsLoading}
                    />
                ) : (
                    <TrackOrderScreen focusKey="TRACK-ORDER-SCREEN" />
                )}
            </div>
        </FocusContext.Provider>
    );
};

export default TrackOrderScreenLayout;
